import { all } from "redux-saga/effects";
import authSaga from "./auth/authSaga";
import staffSaga from "../features/staff/redux/staff.saga";
import roleSaga from "../features/role/redux/role.saga";
import permissionSaga from "../features/permission/redux/permission.saga";
import merchantSaga from "../features/merchant/redux/merchant.saga";
import merchantRequestSaga from "../features/merchant-request/redux/merchantRequest.saga";
import bannerSaga from "../features/banner/redux/banner.saga";
import popupSaga from "../features/popup/redux/popup.saga";

import storeSaga from "../features/store/redux/store.saga";
import customerSaga from "features/customer/redux/customer.saga";
import brandSaga from "features/brand/redux/brand.saga";
import modelSaga from "features/model/redux/model.saga";
import newsSaga from "features/news/redux/news.saga";
import appointmentSaga from "features/appointment/redux/appointment.saga";
import carCareAppointmentSaga from "features/car-care-appointment/redux/car-care-appointment.saga";
import bookServiceSaga from "features/book-service/redux/bookService.saga";
import serviceSaga from "features/service/redux/service.saga";
import serviceCategorySaga from "features/service-category/redux/serviceCategory.saga";
import showroomSaga from "features/showroom/redux/showroom.saga";
import purchaseSaga from "features/purchase/redux/purchase.saga";
import categorySaga from "features/category/redux/category.saga";
import reasonCancelBooking from "features/reason-cancel-booking/redux/reasonCancelBooking.saga";
import notificationSaga from "features/notification/redux/notification.saga";
import notificationManageSaga from "features/notification-manage/redux/notification.saga";
import announcementSaga from "features/announcement/redux/announcement.saga";
import surveySaga from "features/survey-answer/redux/survey-answer.saga";
import contactSupportSaga from "features/request-services/contact-support/redux/contact_support.saga";
import affiliateTransactionsSaga from "features/affiliate/transactions/redux/transactions.saga";
import collaboratorSaga from "features/affiliate/collaborators/redux/collaborator.saga";
import affiliatePaymentSaga from "features/affiliate/payment/redux/payment.saga";
import postSaga from "features/community/post/redux/post.saga";
import loyaltyCampaignSaga from "features/loyalty/campaign/redux/campaign.saga";
import loyaltyVoucherSaga from "features/loyalty/voucher/redux/voucher.saga";
import ratingSaga from "features/rating/redux/ratingContent.saga";
import partTypeSaga from "features/part-type/redux/partType.saga";
import hotSaleSaga from "features/hot-sale/redux/hot-sale.saga";
import formRequestSaga from "features/webapp/form-request/redux/form-request.saga";
import investmentSaga from "features/webapp/investment/redux/investment.saga";
import webappHorizontalBannerSaga from "features/banner/WEBAPP/redux/wepapp-horizontal-banner.saga";
import webappVerticalBannerSaga from "features/banner/WEBAPP/redux/wepapp-vertical-banner.saga";
import auctionSaga from "features/auction/redux/auction.saga";
import subscriptionTransactionSaga from "features/subscription-transaction/redux/subscription-transaction.saga";
import subscriptionPackageSaga from "features/subscription-class/redux/subscription-package.saga";
import reconciliationSaga from "features/reconciliation/redux/reconciliation.saga";
import carCareCategorySaga from "features/car-care-category/redux/car-care-category.saga";
import carCareSaga from "features/car-care/redux/car-care.saga";
import partnerSaga from "features/partner/redux/partner.saga";
import surveyNewSaga from "features/survey/redux/survey.saga";
import accessoriesOrderSaga from "features/accessories-order/redux/accessories-order.saga";
import commissionPolicySaga from "features/affiliate/commission-policy/redux/commission-policy.saga";
import conversionSaga from "features/affiliate/conversion/redux/conversion.saga";
import saleStaffSaga from "features/sale-staffs/redux/sale-staff.saga";

export default function* rootSaga() {
	yield all([
		...authSaga,
		...staffSaga,
		...roleSaga,
		...permissionSaga,
		...merchantSaga,
		...merchantRequestSaga,
		...bannerSaga,
		...storeSaga,
		...customerSaga,
		...brandSaga,
		...modelSaga,
		...newsSaga,
		...hotSaleSaga,
		...appointmentSaga,
		...carCareAppointmentSaga,
		...serviceSaga,
		...serviceCategorySaga,
		...bookServiceSaga,
		...showroomSaga,
		...purchaseSaga,
		...categorySaga,
		...reasonCancelBooking,
		...notificationSaga,
		...notificationManageSaga,
		...announcementSaga,
		...surveySaga,
		...popupSaga,
		...contactSupportSaga,
		...affiliateTransactionsSaga,
		...collaboratorSaga,
		...affiliatePaymentSaga,
		...postSaga,
		...loyaltyCampaignSaga,
		...loyaltyVoucherSaga,
		...ratingSaga,
		...partTypeSaga,
		...formRequestSaga,
		...investmentSaga,
		...webappHorizontalBannerSaga,
		...webappVerticalBannerSaga,
		...auctionSaga,
		...subscriptionTransactionSaga,
		...subscriptionPackageSaga,
		...reconciliationSaga,
		...carCareCategorySaga,
		...carCareSaga,
		...partnerSaga,
		...surveyNewSaga,
		...accessoriesOrderSaga,
		...commissionPolicySaga,
		...conversionSaga,
		...saleStaffSaga,
	]);
}
